// Comprehensive, authentic product specifications extracted directly from official product labels

export const specificProductSpecs = {
  // 1. Abamectin 1.8% EC
  'abamectin-1-8-ec': {
    urduName: 'ایبامیکٹن 1.8% EC',
    technicalContent: 'Active Ingredient: Abamectin 18gm/Ltr (1.85% w/w) — Glycoside Avermectin Chemistry',
    about: [
      'ایبامیکٹن گلائیکو سائیڈ گروپ سے تعلق رکھنے والا ایک نیا اور منفرد کیڑے مار زہر ہے۔',
      'ایبامیکٹن پی این اے اور ایورمیکٹن بی ون بی کی آمیزش سے تیار کی جاتی ہے۔',
      'ایبامیکٹن اپنے لمسی اور خوراکی اثر کی بدولت کیڑوں کے اعصابی نظام کو مفلوج کر دیتی ہے جس کی وجہ سے کیڑے کھانا پینا چھوڑ دیتے ہیں۔',
      'دواپاشی کے بعد فصل کا نقصان فوری طور پر رک جاتا ہے اور کیڑے تین سے چار دن میں بھوک اور پیاس کی وجہ سے مر جاتے ہیں۔',
      'ایبامیکٹن کے سپرے سے فصل پر کوئی مضر اثرات نہیں پڑتے بلکہ فصل پھر ہری اور صحت مند ہو جاتی ہے۔'
    ],
    modeOfAction: 'ایبامیکٹن اعصابی پیغام رسانی کے نظام (GABA Inhibitor) کو مفلوج کر کے کیڑوں اور سنڈیوں کو غیر متحرک کر دیتا ہے، جس سے وہ خوراک کھانا چھوڑ دیتے ہیں اور ہلاک ہو جاتے ہیں۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'ٹینڈے کی سنڈیاں اور جوئیں (Bollworms & Red Mites)', dosage: '400 ml / acre (۴۰۰ ملی لیٹر)', water: '100 – 120 L' },
      { crop: 'Vegetables (سبزیاں)', urduCrop: 'سبزیاں', target: 'تھرپس، مائٹس اور لیف مائنر', dosage: '300 – 400 ml / acre', water: '100 L' },
      { crop: 'Citrus & Orchards (باغات)', urduCrop: 'باغات', target: 'رسٹ مائٹس اور جوئیں', dosage: '100 ml / 100L water', water: '150 – 200 L' }
    ],
    urduInstructions: [
      'سپرے صبح یا شام کے وقت ٹھنڈے موسم میں کریں تاکہ مکمل افادیت حاصل ہو۔',
      'سپرے کے دوران ناک، منہ اور آنکھوں کی حفاظت کریں اور حفاظتی چشمہ و ماسک پہنیں۔',
      'دوائی کو دھوپ اور گرمی سے دور خشک اور ہوادار جگہ پر رکھیں۔',
      'استعمال سے قبل بوتل کو اچھی طرح ہلا لیں اور خالی بوتل کو گڑھے میں دبا دیں۔'
    ]
  },

  // 2. Acetamiprid 20% SP
  'acetamiprid-20-sp': {
    urduName: 'اسیٹامیپرڈ 20% SP',
    technicalContent: 'Active Ingredient: Acetamiprid 200gm/Kg (20% w/w) — Neonicotinoid Systemic Insecticide',
    about: [
      'کپاس کے نقصان رساں کیڑوں کے کنٹرول کے جدید تقاضوں کے عین مطابق ایک نئی دریافت ہے۔',
      'اسیٹامیپرڈ 20 فیصد ایس پی ایک تیز اثر والی لمسی، جسمی اور سرائیت پذیر کیڑے مار دوا ہے جو کیڑوں کے اعصابی نظام کو بری طرح متاثر کرتی ہے۔',
      'تیزی کے عمل کی وجہ سے سفید مکھی اور دیگر رس چوسنے والے کیڑے فوراً ہلاک ہونا شروع ہو جاتے ہیں اور فصل کا نقصان رک جاتا ہے۔',
      'اسیٹامیپرڈ 20 فیصد ایس پی انڈہ کش (Ovicidal)، بچہ کش (Nymphicidal) اور بالغ کش (Adulticidal) خصوصیات رکھتا ہے۔'
    ],
    modeOfAction: 'کیڑوں کے اعصابی نظام میں موجود نکوٹینک ریسیپٹرز پر اثر انداز ہو کر رس چوسنے والے کیڑوں کی تمام حالتوں (انڈے، بچے اور بالغ) کا مکمل صفایا کرتا ہے۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'سفید مکھی، سبز تیلا، تھرپس', dosage: '125 gm / acre (۱۲۵ گرام)', water: '100 – 120 L' },
      { crop: 'Vegetables & Orchards (سبزیاں و باغات)', urduCrop: 'سبزیاں و باغات', target: 'سفید مکھی، تھرپس، لیف ہاپر، ایفڈز، لیف مائنر، ڈائمنڈ بیک ماتھ', dosage: '125 gm (1 gm / L water)', water: '100 – 125 L' },
      { crop: 'Tobacco (تمباکو)', urduCrop: 'تمباکو', target: 'ایفڈز اور سوسری', dosage: '125 gm / acre', water: '100 L' }
    ],
    urduInstructions: [
      'دوا چونکہ پاؤڈر کی حالت میں ہے اس لئے پہلے تھوڑے پانی میں اچھی طرح گھول بنائیں۔',
      'ہوا کے مخالف رخ ہرگز سپرے نہ کریں۔',
      'سپرے کے بعد پورے جسم اور کپڑوں کو صابن اور صاف پانی سے دھو لیں۔',
      'بچوں اور جانوروں کی پہنچ سے دور 25 ڈگری سینٹی گریڈ سے کم درجہ حرارت پر رکھیں۔'
    ]
  },

  // 3. Bifenthrin 10% EC
  'bifenthrin-10-ec-250': {
    urduName: 'بائی فینتھرین 10% EC',
    technicalContent: 'Active Ingredient: Bifenthrin 100gm/Ltr (10.50% w/w) — Synthetic Pyrethroid Insecticide',
    about: [
      'بائی فینتھرین پائریٹھرائیڈ گروپ سے تعلق رکھنے والا انتہائی طاقتور زہر ہے۔',
      'کپاس کے رس چوسنے والے کیڑوں (سفید مکھی، سبز تیلا وغیرہ)، ڈوڈیوں اور ٹینڈوں کی سنڈیوں کے ساتھ ساتھ جوؤں کی مکمل تلفی کرتا ہے۔',
      'بائی فینتھرین دیر پا اثر رکھتا ہے، فصل میں خنکی پیدا نہیں کرتی اور فصل کو سر سبز رکھتا ہے۔',
      'بائی فینتھرین کا پودوں پر اثر موسم کی شدت سے متاثر نہیں ہوتا۔',
      'تصدیقی عمل کی وجہ سے کیڑوں کے پروانے سپرے شدہ کھیتوں میں آنے سے اجتناب کرتے ہیں۔ امریکن سنڈی کے خلاف پیشگی تحفظ فراہم کرتا ہے۔'
    ],
    modeOfAction: 'کیڑوں کے اعصابی نظام کے سوڈیم چینلز کو بلاک کر کے تیز ترین لمسی و خوراکی ناک ڈاؤن اور ریپیلنٹ اثر دیتا ہے۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'سبز تیلا، سفید مکھی، جوئیں، گلابی، چتکبری اور امریکن سنڈی', dosage: '250 – 500 ml / acre', water: '100 – 120 L' },
      { crop: 'Citrus (سٹرس / کینو)', urduCrop: 'سٹرس / کینو', target: 'لیف مائنر (Citrus Leafminer)', dosage: '40 ml / 100L water', water: '150 – 200 L' },
      { crop: 'Mango (آم)', urduCrop: 'آم', target: 'ہاپر ز (Mango Hoppers)', dosage: '40 ml / 100L water', water: '150 – 200 L' },
      { crop: 'Apple (سیب)', urduCrop: 'سیب', target: 'جوئیں (Mites)', dosage: '40 ml / 100L water', water: '150 – 200 L' }
    ],
    urduInstructions: [
      'سپرے ٹینک کو پانی سے آدھا بھریں، تیار شدہ محلول ڈال کر بقیہ پانی سے مقررہ حد تک بھر لیں۔',
      'سپرے کے بعد ہاتھ اور منہ صابن سے اچھی طرح دھو لیں۔',
      'دوائی کو اصل پیکنگ میں سورج کی روشنی اور گرمی سے دور رکھیں۔'
    ]
  },
  'bifenthrin-10-ec-500': {
    urduName: 'بائی فینتھرین 10% EC (500ml)',
    technicalContent: 'Active Ingredient: Bifenthrin 100gm/Ltr (10.50% w/w) — Synthetic Pyrethroid Insecticide',
    about: [
      'بائی فینتھرین پائریٹھرائیڈ گروپ سے تعلق رکھنے والا انتہائی طاقتور زہر ہے۔',
      'کپاس کے رس چوسنے والے کیڑوں، ٹینڈوں کی سنڈیوں اور جوؤں کے خاتمے کیلئے لاجواب اثر رکھتا ہے۔',
      'فصل کو دیرپا تحفظ فراہم کرتا ہے اور پودے سرسبز و شاداب رہتے ہیں۔'
    ],
    modeOfAction: 'سوڈیم چینل ماڈیولیشن کے ذریعے کیڑوں کو فوری مفلوج کرتا ہے۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'سبز تیلا، سفید مکھی، جوئیں، گلابی اور امریکن سنڈی', dosage: '250 – 500 ml / acre', water: '100 – 120 L' },
      { crop: 'Sugarcane (گنا)', urduCrop: 'گنا', target: 'دیمک اور بورر', dosage: '500 – 1000 ml / acre', water: '120 – 150 L' }
    ],
    urduInstructions: [
      'سپرے صبح یا شام کے وقت ٹھنڈے موسم میں کریں۔',
      'حفاظتی دستانے اور چشمہ استعمال کریں۔'
    ]
  },
  'bifenthrin-10-ec-1000': {
    urduName: 'بائی فینتھرین 10% EC (1000ml)',
    technicalContent: 'Active Ingredient: Bifenthrin 100gm/Ltr (10.50% w/w) — Synthetic Pyrethroid Insecticide',
    about: [
      'بائی فینتھرین پائریٹھرائیڈ گروپ سے تعلق رکھنے والا انتہائی طاقتور زہر ہے۔',
      'کپاس کے رس چوسنے والے کیڑوں، ٹینڈوں کی سنڈیوں اور جوؤں کے خاتمے کیلئے لاجواب اثر رکھتا ہے۔'
    ],
    modeOfAction: 'سوڈیم چینل ماڈیولیشن کے ذریعے کیڑوں کو فوری مفلوج کرتا ہے۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'سبز تیلا، سفید مکھی، جوئیں، گلابی اور امریکن سنڈی', dosage: '250 – 500 ml / acre', water: '100 – 120 L' }
    ],
    urduInstructions: [
      'سپرے صبح یا شام کے وقت ٹھنڈے موسم میں کریں۔'
    ]
  },

  // 4. Ceedo 20% SC (Clothianidin)
  'ceedo-20-sc-200': {
    urduName: 'سیڈو 20% SC',
    technicalContent: 'Active Ingredient: Clothianidin 200gm/Ltr (17.81% w/w) — Neonicotinoid Broad Spectrum Insecticide',
    about: [
      'سیڈو ایک جدید اسٹینڈرڈ پروٹیکٹری کیڑے مار دوائی ہے جو کہ نیو نکوٹینوائیڈ (Neonicotinoid) گروپ سے تعلق رکھتا ہے۔',
      'سیڈو لمسی (Contact)، معدی (Stomach)، سرایت پذیری (Systemic) اور پودوں کے آر پار ہونے کی صلاحیت (Translaminar) رکھتا ہے۔',
      'مختلف فصلات مثلاً کپاس، دھان، گندم، مکئی، سبزیجات اور باغات میں رس چوسنے والے کیڑوں کو مکمل کنٹرول کرتا ہے۔',
      'سیڈو کیڑوں کو کنٹرول کر کے فصل کی نشوونما کو بہتر بناتا ہے اور فصل کو قدرتی حالت میں سرسبز و شاداب رکھتا ہے۔'
    ],
    modeOfAction: 'اعصابی خلیات کے نکوٹینک ریسیپٹرز پر حاوی ہو کر سگنل ٹرانسمیشن منقطع کر دیتا ہے جس سے رس چوسنے والے کیڑے فوری ہلاک ہو جاتے ہیں۔',
    dosageTable: [
      { crop: 'Rice / Paddy (دھان / چاول)', urduCrop: 'دھان / چاول', target: 'پلانٹ ہاپر، سبز تیلا اور رس چوسنے والے کیڑے', dosage: '200 – 250 ml / acre', water: '100 – 120 L' },
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'سفید مکھی، جسیڈ اور تھرپس', dosage: '200 – 250 ml / acre', water: '100 – 120 L' },
      { crop: 'Vegetables & Orchards (سبزیاں و باغات)', urduCrop: 'سبزیاں و باغات', target: 'پتوں کے رس چوسنے والے کیڑے', dosage: '200 – 250 ml / 100L water', water: '100 – 150 L' }
    ],
    urduInstructions: [
      'سپرے صبح یا شام کے وقت کریں جب پودوں پر اوس نہ ہو۔',
      'سپرے کے دوران کھانے پینے اور تمباکو نوشی سے پرہیز کریں۔',
      'خالی بوتل کو گڑھے میں دبا دیں اور پانی کے ذخیروں سے دور رکھیں۔'
    ]
  },
  'ceedo-20-sc-1000': {
    urduName: 'سیڈو 20% SC (1000ml)',
    technicalContent: 'Active Ingredient: Clothianidin 200gm/Ltr (17.81% w/w) — Neonicotinoid Broad Spectrum Insecticide',
    about: [
      'سیڈو ایک جدید اسٹینڈرڈ پروٹیکٹری کیڑے مار دوائی ہے جو کہ نیو نکوٹینوائیڈ (Neonicotinoid) گروپ سے تعلق رکھتا ہے۔',
      'مختلف فصلات مثلاً کپاس، دھان، گندم، مکئی، سبزیجات اور باغات میں رس چوسنے والے کیڑوں کو مکمل کنٹرول کرتا ہے۔'
    ],
    modeOfAction: 'اعصابی خلیات کے نکوٹینک ریسیپٹرز پر حاوی ہو کر کیڑوں کو فوری مفلوج کرتا ہے۔',
    dosageTable: [
      { crop: 'Rice (چاول)', urduCrop: 'چاول', target: 'پلانٹ ہاپر، تیلا اور رس چوسنے والے کیڑے', dosage: '200 – 250 ml / acre', water: '100 – 120 L' }
    ],
    urduInstructions: [
      'سپرے کے دوران حفاظتی تدابیر اختیار کریں۔'
    ]
  },

  // 5. Chlorfenapyr 36% SC
  'chlorfenapyr-36-sc': {
    urduName: 'کلورفیناپائر 36% SC',
    technicalContent: 'Active Ingredient: Chlorfenapyr 360gm/Ltr (30.50% w/w) — Pyrrole Class Pro-Insecticide',
    about: [
      'کلورفیناپائر ایک وسیع الاثر کیڑے مار اور جوئیں مار زہر ہے جو کہ نئے گروپ پائرول (Pyrrole) سے تعلق رکھتا ہے۔',
      'کلورفیناپائر کپاس پر موجود رس چوسنے والے کیڑوں اور سنڈیوں کے علاوہ جوؤں کا بھی فوری خاتمہ کر کے فصل کی نشوونما کو شاندار بناتا ہے۔',
      'کلورفیناپائر واسکولر ٹشو ایکٹیو ہونے کی وجہ سے مفید اور دوست کیڑوں پر اثر انداز نہیں ہوتا اس لئے ماحول کا نظام متاثر نہیں ہوتا۔',
      'یہ زہر مربوط طریقہ انسداد (IPM) کے لئے بہترین انتخاب ہے۔'
    ],
    modeOfAction: 'کیڑوں کے خلیات میں مائٹوکونڈریل پروٹون گریڈینٹ کو غیر مستحکم کر کے اے ٹی پی انرجی کی پیداوار روک دیتا ہے جس سے کیڑے تیزی سے تلف ہو جاتے ہیں۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'تھرپس، جسیڈ ز اور مائٹس (Thrips, Jassids & Mites)', dosage: '225 ml / acre (۲۲۵ ملی لیٹر)', water: '100 – 120 L' },
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'امریکن سنڈی (American Bollworm)', dosage: '320 ml / acre (۳۲۰ ملی لیٹر)', water: '100 – 120 L' },
      { crop: 'Vegetables (سبزیاں)', urduCrop: 'سبزیاں', target: 'مائٹس اور تھرپس', dosage: '200 – 250 ml / acre', water: '100 L' }
    ],
    urduInstructions: [
      'سپرے کے دوران ناک منہ اور آنکھوں کی حفاظت کریں اور حفاظتی چشمہ اور ماسک پہنیں۔',
      'سپرے سے فارغ ہو کر پورے جسم اور کپڑوں کو اچھی طرح صابن اور صاف پانی سے دھو لیں۔',
      'دوائی کو اصل پیکنگ میں سورج کی روشنی، گرمی اور نمی سے دور ہوا دار جگہ پر رکھا جائے۔'
    ]
  },

  // 6. Cypermethrin 10% EC
  'cypermethrin-10-ec-250': {
    urduName: 'سائپرمیتھرین 10% EC',
    technicalContent: 'Active Ingredient: Cypermethrin 100gm/Ltr (10.7% w/w) — Synthetic Pyrethroid Fast-Knockdown',
    about: [
      'سائپرمیتھرین پائریٹھرائیڈ گروپ سے تعلق رکھنے والا ایک انتہائی موثر زہر ہے۔',
      'مختلف فصلات خصوصاً کپاس کی فصل پر پائی جانے والی گلابی اور چتکبری سنڈیوں کے تدارک کے لیے بہترین زہر ہے۔',
      'تیز ترین لمسی اثر کے ذریعے کیڑوں کا فوری خاتمہ کر کے فصل کو محفوظ بناتا ہے۔'
    ],
    modeOfAction: 'کیڑوں کے اعصابی نظام کے وولٹیج گیٹڈ سوڈیم چینلز کو مسلسل متحرک رکھ کر اعصابی فالج اور موت کا سبب بنتا ہے۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'گلابی اور چتکبری سنڈی (Spotted & Pink Bollworm)', dosage: '250 ml / acre (۲۵۰ ملی لیٹر)', water: '100 – 120 L' },
      { crop: 'Vegetables (سبزیاں)', urduCrop: 'سبزیاں', target: 'فروٹ بورر اور کیٹرپلرز', dosage: '200 – 250 ml / acre', water: '100 L' }
    ],
    urduInstructions: [
      'سپرے صبح یا شام کے وقت کریں اور تیز دھوپ سے بچیں۔',
      'سپرے کرتے وقت حفاظتی لباس اور ماسک پہنیں۔'
    ]
  },
  'cypermethrin-10-ec-1000': {
    urduName: 'سائپرمیتھرین 10% EC (1000ml)',
    technicalContent: 'Active Ingredient: Cypermethrin 100gm/Ltr (10.7% w/w) — Synthetic Pyrethroid Fast-Knockdown',
    about: [
      'سائپرمیتھرین پائریٹھرائیڈ گروپ سے تعلق رکھنے والا ایک انتہائی موثر زہر ہے۔',
      'مختلف فصلات خصوصاً کپاس کی فصل پر پائی جانے والی گلابی اور چتکبری سنڈیوں کے تدارک کے لیے بہترین زہر ہے۔'
    ],
    modeOfAction: 'کیڑوں کے اعصابی نظام کو فالج زدہ کر کے فوری ہلاک کرتا ہے۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'گلابی اور چتکبری سنڈی', dosage: '250 ml / acre', water: '100 – 120 L' }
    ],
    urduInstructions: [
      'حفاظتی تدابیر اختیار کریں۔'
    ]
  },

  // 7. Dimethoate 40% EC
  'dimethoate-40': {
    urduName: 'ڈائی میتھوایٹ 40% EC',
    technicalContent: 'Active Ingredient: Dimethoate 400gm/Ltr (38.7% w/w) — Organophosphate Systemic Insecticide & Acaricide',
    about: [
      'ڈائی میتھوایٹ آرگینو فاسفیٹ گروپ کا ایک وسیع دائرہ عمل والا کیڑے مار زہر ہے جو اپنے لمسی اور خوراکی اثر کے ذریعے کیڑوں کا خاتمہ کرتا ہے۔',
      'ڈائی میتھوایٹ مختلف فصلات خصوصاً کپاس اور اس کے علاوہ چارہ اور دیگر پودوں پر حملہ آور ہونے والے جسیڈ، تھرپس ، ایفڈ اور کماد کی پائر یلا (Pyrilla) وغیرہ کا بہترین کنٹرول کرتا ہے۔',
      'پودے کے اندر گہرائی تک جذب ہو کر چھپے ہوئے رس چوسنے والے کیڑوں کا خاتمہ کرتا ہے۔'
    ],
    modeOfAction: 'کیڑوں میں ایسٹیل کولین ایسٹریز انزائم کی سرگرمی کو روک کر مسلسل اعصابی جھٹکے اور فالج پیدا کرتا ہے۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'جسیڈ ، تھرپس اور ایفڈز', dosage: '400 ml / acre (۴۰۰ ملی لیٹر)', water: '100 – 120 L' },
      { crop: 'Potato (آلو)', urduCrop: 'آلو', target: 'جسیڈ اور ایفڈ', dosage: '400 ml / acre (۴۰۰ ملی لیٹر)', water: '100 – 120 L' },
      { crop: 'Tobacco (تمباکو)', urduCrop: 'تمباکو', target: 'ایفڈز', dosage: '400 ml / acre (۴۰۰ ملی لیٹر)', water: '100 L' },
      { crop: 'Sugarcane (کماد)', urduCrop: 'کماد', target: 'کماد کی پائریلا (Pyrilla)', dosage: '400 ml / acre (۴۰۰ ملی لیٹر)', water: '120 – 150 L' },
      { crop: 'Oilseeds (تیل دار اجناس)', urduCrop: 'تیل دار اجناس', target: 'سست تیلا / ایفڈ', dosage: '400 ml / acre (۴۰۰ ملی لیٹر)', water: '100 L' }
    ],
    urduInstructions: [
      'سپرے کے بعد 21 دن تک فصل کو برداشت نہ کریں (Pre-Harvest Interval: 21 Days)۔',
      'ہوا کے رخ کے مخالف سپرے نہ کریں۔',
      'سپرے کے دوران تمباکو نوشی اور کھانے پینے سے گریز کریں۔'
    ]
  },

  // 8. Dumei 50% WG (Flonicamid)
  'dumei-50-120': {
    urduName: 'ڈیومی 50% WG',
    technicalContent: 'Active Ingredient: Flonicamid 500gm/Kg (50% w/w) — Pyridinecarboxamide Selective Insecticide',
    about: [
      'ڈیومی کے کیمیائی خاندان نیو نکوٹینا ئیڈ (Neonicotinoid) کا انتہائی طاقتور اور لمسی اثر والا پر کشادہ، جدید اور منفرد زہر ہے۔',
      'یہ کیڑوں کے اعصابی نظام میں موجود ایسیٹائل کولین ریسیپٹرز (Acetylcholine Receptors) پر اثر انداز ہو کر اس کو مفلوج کر دیتا ہے۔',
      'ڈیومی چار علیحدہ طریقوں یعنی سرائیت پذیری، لمسی اثر ، معدی اثر اور آر پار جذب ہونے کی صلاحیت کی وجہ سے رس چوسنے والے کیڑوں کو کنٹرول کرتا ہے۔',
      'ڈیومی کو مختلف فصلات کے رس چوسنے والے کیڑوں کے مکمل خاتمے کے لیے ہر مرحلے میں تنہا یا دوسری زہروں کے ساتھ استعمال کیا جا سکتا ہے۔'
    ],
    modeOfAction: 'کیڑوں کے منہ کے اعضاء میں فیڈنگ انہبیشن پیدا کرتا ہے جس سے رس چوسنے والے کیڑے فوری طور پر کھانا پینا چھوڑ کر بھوک سے مر جاتے ہیں۔',
    dosageTable: [
      { crop: 'Rice / Paddy (دھان / چاول)', urduCrop: 'دھان / چاول', target: 'پلانٹ ہاپر، سفید پشت تیلا اور بھورا تیلا (BPH & WBPH)', dosage: '48 سے 60 گرام فی ایکڑ', water: '100 – 120 L' },
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'سفید مکھی اور جسیڈز', dosage: '60 – 80 گرام فی ایکڑ', water: '100 – 120 L' },
      { crop: 'Vegetables (سبزیاں)', urduCrop: 'سبزیاں', target: 'ایفڈز اور تھرپس', dosage: '40 – 60 گرام فی ایکڑ', water: '100 L' }
    ],
    urduInstructions: [
      'نوٹ: سپرے شام کے وقت کریں۔',
      'سپرے ٹینک کو پہلے صاف پانی سے آدھا بھریں پھر گھول ڈالیں۔',
      'بچوں کی پہنچ سے دور خشک اور سایہ دار جگہ پر اسٹور کریں۔'
    ]
  },
  'dumei-50-wg-60': {
    urduName: 'ڈیومی 50% WG (60gm)',
    technicalContent: 'Active Ingredient: Flonicamid 500gm/Kg (50% w/w) — Pyridinecarboxamide Selective Insecticide',
    about: [
      'ڈیومی جدید اور منفرد فارمولیشن ہے جو دھان اور کپاس کے رس چوسنے والے کیڑوں کے خلاف تیر بہدف اثر رکھتی ہے۔',
      'پلانٹ ہاپرز کو فیڈنگ روک کر فوری تلف کرتی ہے اور فصل کو سرسبز رکھتی ہے۔'
    ],
    modeOfAction: 'کیڑوں کی غذا حاصل کرنے کی حس کو منقطع کر کے ہلاک کرتا ہے۔',
    dosageTable: [
      { crop: 'Rice (دھان)', urduCrop: 'دھان', target: 'پلانٹ ہاپر', dosage: '48 سے 60 گرام فی ایکڑ', water: '100 – 120 L' }
    ],
    urduInstructions: [
      'سپرے شام کے وقت ٹھنڈے موسم میں کریں۔'
    ]
  },

  // 9. Dursban 40% EC (Chlorpyrifos)
  'dursban-40-ec-250': {
    urduName: 'ڈرسٹین 40% EC',
    technicalContent: 'Active Ingredient: Chlorpyrifos 400 G/L (38.10% w/w) — Organophosphate Broad-Spectrum & Soil Insecticide',
    about: [
      'ڈرسٹین آرگینو فاسفیٹ گروپ میں سب سے زیادہ استعمال ہونے والا زہر ہے۔',
      'یہ لمسی اور خوراکی اثر رکھنے کے علاوہ بھاپ (Fumigation) کی صورت میں چھپے ہوئے کیڑوں تک پہنچ کر انہیں ختم کر دیتا ہے۔',
      'کلورو پائری فاس پودے کے مومی مادے (Wax Material) میں جذب ہو جاتی ہے جس کی وجہ سے سنڈیاں کہیں بھی نہیں بچ سکتیں۔',
      'ڈرسٹین کا اثر بارش اور تیز دھوپ سے زائل نہیں ہوتا۔',
      'انتباہ: اس زرعی زہر کا استعمال دھان کی فصل پر ممنوع ہے۔'
    ],
    modeOfAction: 'کیڑوں کے اندر کولین ایسٹریز انزائم کو غیر فعال کر کے اعصابی نظام کو تباہ کرتا ہے اور فیومیگیشن کے ذریعے مٹی اور تنوں میں چھپے کیڑے بھی ہلاک کرتا ہے۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'امریکن، لشکری، گلابی، چتکبری سنڈیاں، سفید مکھی، تھرپس، جسیڈ، ایفڈ', dosage: '1000 ml / acre (۱۰۰۰ ملی لیٹر)', water: '100 – 120 L' },
      { crop: 'Sugarcane (کماد)', urduCrop: 'کماد', target: 'بوررز اور بگز', dosage: '1000 ml / acre (۱۰۰۰ ملی لیٹر)', water: '120 – 150 L' },
      { crop: 'Maize (مکئی)', urduCrop: 'مکئی', target: 'بورر اور فال آرمی ورم', dosage: '1000 ml / acre (۱۰۰۰ ملی لیٹر)', water: '100 – 120 L' },
      { crop: 'Orchards (باغات)', urduCrop: 'باغات', target: 'کاڈلنگ ماتھ اور اسکیل کیڑے', dosage: '200 – 300 ml / 100L water', water: '150 – 200 L' },
      { crop: 'Vegetables (سبزیات)', urduCrop: 'سبزیات', target: 'غنڈیر اور سنڈیاں', dosage: '800 – 1000 ml / acre', water: '100 – 120 L' }
    ],
    urduInstructions: [
      'انتباہ: اس زرعی زہر کا استعمال دھان کی فصل پر ممنوع ہے۔',
      'استعمال سے قبل بوتل کو اچھی طرح ہلا لیں۔',
      'سپرے کے دوران حفاظتی چشمہ اور ماسک پہنیں۔'
    ]
  },
  'dursban-40-ec-1000': {
    urduName: 'ڈرسٹین 40% EC (1000ml)',
    technicalContent: 'Active Ingredient: Chlorpyrifos 400 G/L (38.10% w/w) — Organophosphate Broad-Spectrum & Soil Insecticide',
    about: [
      'ڈرسٹین آرگینو فاسفیٹ گروپ میں سب سے زیادہ استعمال ہونے والا زہر ہے۔',
      'یہ لمسی، خوراکی اور فیومیگیشن اثرات کے ذریعے کیڑوں کا مکمل خاتمہ کرتا ہے۔',
      'انتباہ: اس زرعی زہر کا استعمال دھان کی فصل پر ممنوع ہے۔'
    ],
    modeOfAction: 'اعصابی نظام کے کولین ایسٹریز انزائم کو بلاک کر کے سنڈیوں اور دیمک کا خاتمہ کرتا ہے۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'امریکن، لشکری، گلابی سنڈیاں اور دیمک', dosage: '1000 ml / acre', water: '100 – 120 L' },
      { crop: 'Sugarcane (کماد)', urduCrop: 'کماد', target: 'بوررز اور دیمک', dosage: '1000 ml / acre', water: 'Flood / 150 L' }
    ],
    urduInstructions: [
      'دھان کی فصل پر استعمال نہ کریں۔',
      'بچوں اور مویشیوں کی پہنچ سے دور رکھیں۔'
    ]
  },
  'dursban-40-ec-imported': {
    urduName: 'ڈرسٹین 40% EC امپورٹڈ (1000ml)',
    technicalContent: 'Active Ingredient: Chlorpyrifos 400 G/L (38.10% w/w) — Organophosphate Broad-Spectrum',
    about: [
      'امپورٹڈ ہائی گریڈ کلورو پائری فاس 40% فارمولیشن۔',
      'دیمک، سنڈیوں اور بوررز کے خلاف سب سے زیادہ قابل اعتماد اثر۔'
    ],
    modeOfAction: 'لمسی، خوراکی اور بھاپ کے اثر سے کیڑوں کی فوری ہلاکت۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'لشکری و امریکن سنڈیاں', dosage: '1000 ml / acre', water: '100 – 120 L' }
    ],
    urduInstructions: [
      'دھان کی فصل پر ممنوع ہے۔'
    ]
  },

  // 10. Emamectin Benzoate 1.9% EC
  'emamectin-1-9-ec-200': {
    urduName: 'ایمامیکٹن بینزوئیٹ 1.9% EC',
    technicalContent: 'Active Ingredient: Emamectin Benzoate 19gm/Ltr (2.1% w/w) — Avermectin Bio-Fermentation Insecticide',
    about: [
      'ایمامیکٹن جدید ریسرچ پر مبنی امریکن سنڈی کے موثر کنٹرول کیلئے ایک منفرد کیمسٹری کا زرعی زہر ہے۔',
      'جو کہ قدرتی بیکٹیریا سٹرپٹومائیس ایورمیٹالس (Streptomyces Avermitilis) کے فرمنٹیشن طریقہ سے حاصل کیا گیا ہے۔',
      'ایمامیکٹن نقصان دہ کیڑوں کو گلنے، چھونے اور کھانے سے کنٹرول کرتا ہے۔ کیڑوں کے اعصابی نظام میں پیغام رساں اعصاب کو مفلوج کرتا ہے۔',
      'نتیجتاً سنڈیاں دو بائی طور پر مفلوج ہو کر کھانا بند کر دیتی ہیں، پودوں کا نقصان رک جاتا ہے اور سنڈیاں گھنٹوں میں مرنے لگتی ہیں۔',
      'ٹرانسلیمنر ایکشن (Translaminar Action) کی بدولت زہر کا اثر زیادہ دیر تک برقرار رہتا ہے۔ کم شرح استعمال سے ماحول پر بھی مضر اثر نہیں پڑتا۔'
    ],
    modeOfAction: 'گلوٹامیٹ گیٹڈ کلورائیڈ چینلز پر اثر انداز ہو کر پٹھوں کے مسلسل فالج کا سبب بنتا ہے، جس سے سنڈیاں گھنٹوں میں خوراک بند کر کے ہلاک ہو جاتی ہیں۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'امریکن سنڈی، گلابی سنڈی اور لشکری سنڈی', dosage: '200 ml / acre (۲۰۰ ملی لیٹر)', water: '100 – 120 L' },
      { crop: 'Maize (مکئی)', urduCrop: 'مکئی', target: 'فال آرمی ورم اور کورن ائیر ورم', dosage: '200 – 300 ml / acre', water: '100 – 120 L' },
      { crop: 'Vegetables (سبزیاں)', urduCrop: 'سبزیاں', target: 'ڈائمنڈ بیک ماتھ، فروٹ بورر اور کیٹرپلرز', dosage: '200 ml / acre', water: '100 L' }
    ],
    urduInstructions: [
      'سپرے صبح کے وقت یا شام کو ٹھنڈے موسم میں کریں۔',
      'سپرے کے دوران حفاظتی چشمہ اور ماسک لازمی پہنیں۔',
      'فصل کو سپرے کے 7 دن بعد تک برداشت نہ کریں۔'
    ]
  },
  'emamectin-1-9-ec-1000': {
    urduName: 'ایمامیکٹن بینزوئیٹ 1.9% EC (1000ml)',
    technicalContent: 'Active Ingredient: Emamectin Benzoate 19gm/Ltr (2.1% w/w) — Avermectin Bio-Fermentation Insecticide',
    about: [
      'ایمامیکٹن جدید ریسرچ پر مبنی امریکن سنڈی کے موثر کنٹرول کیلئے ایک منفرد کیمسٹری کا زرعی زہر ہے۔',
      'قدرتی بیکٹیریا کے فرمنٹیشن پروسیس سے حاصل شدہ ماحول دوست زہر۔'
    ],
    modeOfAction: 'سنڈیوں کے پٹھوں اور اعصاب کو مفلوج کر کے خوراک بند کرواتا ہے۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'امریکن و لشکری سنڈی', dosage: '200 ml / acre', water: '100 – 120 L' }
    ],
    urduInstructions: [
      'سپرے ٹھنڈے اوقات میں کریں۔'
    ]
  },
  'emamectin-1-9-ec-imported-1000': {
    urduName: 'ایمامیکٹن 1.9% EC امپورٹڈ (1000ml)',
    technicalContent: 'Active Ingredient: Emamectin Benzoate 19gm/Ltr (2.1% w/w) — Avermectin Formulation',
    about: [
      'اعلی معیار کا امپورٹڈ ایمامیکٹن بینزوئیٹ فارمولیشن۔',
      'سنڈیوں کے خلاف دیرپا کنٹرول اور شاندار ٹرانسلیمنر صلاحیت۔'
    ],
    modeOfAction: 'سنڈیوں کے اعصابی نظام کو مفلوج کر کے فوری ہلاک کرتا ہے۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'امریکن، گلابی و لشکری سنڈی', dosage: '200 ml / acre', water: '100 – 120 L' }
    ],
    urduInstructions: [
      'حفاظتی تدابیر اختیار کریں۔'
    ]
  },
  'emamectin-1-9-ec-imported-400': {
    urduName: 'ایمامیکٹن 1.9% EC امپورٹڈ (400ml)',
    technicalContent: 'Active Ingredient: Emamectin Benzoate 19gm/Ltr (2.1% w/w) — Avermectin Formulation',
    about: [
      'اعلی معیار کا امپورٹڈ ایمامیکٹن بینزوئیٹ فارمولیشن۔'
    ],
    modeOfAction: 'سنڈیوں کے اعصابی نظام کو مفلوج کر کے فوری ہلاک کرتا ہے۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'امریکن و گلابی سنڈی', dosage: '200 ml / acre', water: '100 – 120 L' }
    ],
    urduInstructions: [
      'حفاظتی تدابیر اختیار کریں۔'
    ]
  },
  'emamectin-5-wdg-150': {
    urduName: 'ایمامیکٹن بینزوئیٹ 5% WDG (150gm)',
    technicalContent: 'Active Ingredient: Emamectin Benzoate 50gm/Kg (5% w/w) — Water Dispersible Granules',
    about: [
      'پاؤڈر/گرینول فارم میں اعلی ارتکاز والا ایمامیکٹن 5% ڈبلیو ڈی جی۔',
      'مکئی اور کپاس کی سنڈیوں پر فوری اور دیرپا اثر رکھتا ہے۔',
      'پانی میں یکساں حل پذیر اور دیرپا ٹرانسلیمنر ایکشن فراہم کرتا ہے۔'
    ],
    modeOfAction: 'سنڈیوں کے عضلات کو مفلوج کر کے کھانا بند کرواتا ہے۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'امریکن و لشکری سنڈی', dosage: '75 – 150 gm / acre', water: '100 – 120 L' },
      { crop: 'Maize (مکئی)', urduCrop: 'مکئی', target: 'فال آرمی ورم', dosage: '100 – 150 gm / acre', water: '100 L' }
    ],
    urduInstructions: [
      'گرینولز کو پہلے تھوڑے پانی میں مکمل حل کر کے سپرے ٹینک میں شامل کریں۔'
    ]
  },
  'emamectin-5-wdg-75': {
    urduName: 'ایمامیکٹن بینزوئیٹ 5% WDG (75gm)',
    technicalContent: 'Active Ingredient: Emamectin Benzoate 50gm/Kg (5% w/w) — Water Dispersible Granules',
    about: [
      'پاؤڈر/گرینول فارم میں اعلی ارتکاز والا ایمامیکٹن 5% ڈبلیو ڈی جی۔'
    ],
    modeOfAction: 'سنڈیوں کے عضلات کو مفلوج کر کے کھانا بند کرواتا ہے۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'امریکن و لشکری سنڈی', dosage: '75 gm / acre', water: '100 L' }
    ],
    urduInstructions: [
      'پہلے تھوڑے پانی میں گھول بنائیں۔'
    ]
  },

  // 11. Fentrol (Fipronil) 5% SC
  'fentrol-fipronil-5-480': {
    urduName: 'فینٹرول 5% SC',
    technicalContent: 'Active Ingredient: Fipronil 50gm/Ltr (4.85% w/w) — Phenylpyrazole Broad-Spectrum Insecticide',
    about: [
      'فینٹرول نئی کیمسٹری کا جدید حشرات کش زہر ہے جو مختلف فصلوں پر تنے کی سنڈیوں اور پتے کے کیڑوں پر انتہائی موثر اور دیر پا اثر رکھتا ہے۔',
      'دوسرے ممالک میں چاول کے علاوہ سبزیات، سویابین، مکئی، چقندر اور دوسرے بہت سی فصلوں پر کامیابی سے استعمال ہوتا ہے۔',
      'نوٹ: فینٹرول کو آسٹریلیا اور پاکستان سمیت دوسرے بہت سے ممالک میں گنے پر آنے والے مختلف کیڑوں کے انسداد کیلئے انتہائی کامیابی سے استعمال کیا جا رہا ہے۔'
    ],
    modeOfAction: 'کیڑوں کے اعصابی نظام میں جی اے بی اے (GABA) اور گلوٹامیٹ ریگولیٹڈ کلورائیڈ چینلز کو مسدود کر کے اعصابی تناؤ اور حتمی ہلاکت کا باعث بنتا ہے۔',
    dosageTable: [
      { crop: 'Rice / Paddy (دھان)', urduCrop: 'دھان', target: 'تنے کی سنڈی، لیف فولڈر، ہاپرز (Stem Borer & Leaf Folder)', dosage: '480 ml / acre (۴۸۰ ملی لیٹر)', water: '100 – 120 L' },
      { crop: 'Sugarcane (گنا)', urduCrop: 'گنا', target: 'ارلی شوٹ بورر، روٹ بورر اور دیمک', dosage: '480 – 800 ml / acre', water: '120 – 150 L' },
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'تھرپس اور جسیڈز', dosage: '400 – 480 ml / acre', water: '100 L' }
    ],
    urduInstructions: [
      'سپرے صبح یا شام کے وقت ٹھنڈے موسم میں کریں۔',
      'سپرے ٹینک کو صاف پانی سے بھریں اور گھول کو یکساں حل کریں۔',
      'دوا کو بچوں کی پہنچ سے دور رکھیں۔'
    ]
  },
  'fentrol-fipronil-5-1000': {
    urduName: 'فینٹرول 5% SC (1000ml)',
    technicalContent: 'Active Ingredient: Fipronil 50gm/Ltr (4.85% w/w) — Phenylpyrazole Broad-Spectrum Insecticide',
    about: [
      'فینٹرول نئی کیمسٹری کا جدید حشرات کش زہر ہے جو تنے کی سنڈیوں اور پتے کے کیڑوں پر انتہائی موثر اثر رکھتا ہے۔'
    ],
    modeOfAction: 'اعصابی نظام کو مسدود کر کے کیڑوں کو ہلاک کرتا ہے۔',
    dosageTable: [
      { crop: 'Rice (چاول)', urduCrop: 'چاول', target: 'تنے کی سنڈی اور لیف فولڈر', dosage: '480 – 600 ml / acre', water: '100 – 120 L' },
      { crop: 'Sugarcane (گنا)', urduCrop: 'گنا', target: 'شوٹ بورر اور دیمک', dosage: '480 – 800 ml / acre', water: '120 – 150 L' }
    ],
    urduInstructions: [
      'حفاظتی تدابیر اختیار کریں۔'
    ]
  },

  // 12. Freedom 11.6% SC (CTRPR + EMA)
  'freedom-11-6-100': {
    urduName: 'فریڈم 11.6% SC',
    technicalContent: 'Active Ingredients: Emamectin Benzoate 2.73% W/V (2.6% w/w) + Chlorantraniliprole 9.45% W/V (9.0% w/w)',
    about: [
      'فریڈم جدید فارمولہ پر مشتمل پروڈکٹ ہے۔',
      'فریڈم ٹرانسلیمنر ایکشن کی بدولت کیڑوں کی حفاظت کو فوری ختم کر دیتا ہے۔',
      'جس سے کیڑا حملہ بند کر دیتا ہے اور پودے کے اندر تک اپنا اثر دکھاتا ہے۔',
      'اس طرح فصل کا نقصان نہیں ہوتا اور فصل کے معیار اور پیداوار میں بہتری آتی ہے۔'
    ],
    modeOfAction: 'ریانودین ریسیپٹرز کو فعال کرنے والے کلورانٹرانیلیپرول اور اعصابی فالج پیدا کرنے والے ایمامیکٹن کا طاقتور دوہرا ایکشن جو سنڈیوں کا مکمل صفایا کرتا ہے۔',
    dosageTable: [
      { crop: 'Rice / Paddy (دھان)', urduCrop: 'دھان', target: 'پتہ لپیٹ سنڈی اور تنے کی سنڈی (Leaf Folder & Stem Borer)', dosage: '60 سے 90 ملی لیٹر فی ایکڑ', water: '100 – 120 L' },
      { crop: 'Maize (مکئی)', urduCrop: 'مکئی', target: 'فال آرمی ورم', dosage: '80 – 100 ml / acre', water: '100 L' },
      { crop: 'Vegetables (سبزیاں)', urduCrop: 'سبزیاں', target: 'فروٹ بورر اور کیٹرپلرز', dosage: '60 – 80 ml / acre', water: '100 L' }
    ],
    urduInstructions: [
      'سپرے کے بعد 20 دن تک فصل کو نہ کاٹیں (PHI: 20 Days)۔',
      'سپرے کے دوران حفاظتی چشمہ اور ماسک پہنیں۔'
    ]
  },
  'freedom-11-6-150': {
    urduName: 'فریڈم 11.6% SC (150ml)',
    technicalContent: 'Active Ingredients: Emamectin Benzoate 2.73% W/V (2.6% w/w) + Chlorantraniliprole 9.45% W/V (9.0% w/w)',
    about: [
      'فریڈم جدید فارمولہ پر مشتمل پروڈکٹ ہے۔ دھان کی پتہ لپیٹ سنڈی اور تنے کی سنڈی پر لاجواب اثر رکھتی ہے۔'
    ],
    modeOfAction: 'دوہرے طریقے سے سنڈیوں کے اعصاب اور عضلات کو مفلوج کرتا ہے۔',
    dosageTable: [
      { crop: 'Rice (دھان)', urduCrop: 'دھان', target: 'پتہ لپیٹ سنڈی', dosage: '60 سے 90 ملی لیٹر فی ایکڑ', water: '100 – 120 L' }
    ],
    urduInstructions: [
      'حفاظتی تدابیر اختیار کریں۔'
    ]
  },

  // 13. Gengwei 55% SC (Mesotrione + Atrazine)
  'gengwei-55-sc-1000-imported': {
    urduName: 'گینگوئی 55% SC امپورٹڈ (1000ml)',
    technicalContent: 'Active Ingredients: Mesotrione 50 gm/Ltr (4.38% w/w) + Atrazine 500 gm/Ltr (43.85% w/w) — Selective Post-Emergence Herbicide',
    about: [
      'گینگوئی ایک نیا سرائیت پذیر جڑی بوٹی مار زہر ہے جو کہ مکئی میں اگنے والی تمام گھاس نما (ڈیلا خاندان) اور چوڑے پتوں والی جڑی بوٹیوں کے خاتمے کیلئے انتہائی موثر ہے۔',
      'گینگوئی کا جدید فارمولا دو طاقتور اجزاء کے ملاپ سے بنا ہے جو جڑی بوٹیوں کی جڑوں اور پتوں کے ذریعے جذب ہو کر جڑی بوٹیوں میں کلوروفل بننے کے عمل کو روکتا ہے اور ان کی تلفی کا سبب بنتا ہے۔',
      'امپورٹڈ کوالٹی کے ساتھ مکئی کی فصل کو محفوظ اور جڑی بوٹیوں سے پاک رکھتا ہے۔'
    ],
    modeOfAction: 'میزوٹرائیون ایچ پی پی ڈی انزائم کو روکتی ہے جبکہ ایٹرازین فوٹو سسٹم II کو بلاک کر کے جڑی بوٹیوں میں کلوروفل کو تباہ کر دیتی ہے۔',
    dosageTable: [
      { crop: 'Maize (مکئی)', urduCrop: 'مکئی', target: 'تمام گھاس نما (ڈیلا خاندان) اور چوڑے پتوں والی جڑی بوٹیاں', dosage: '495 سے 727.2 ملی لیٹر فی ایکڑ', water: '100 – 150 L' }
    ],
    urduInstructions: [
      'فصل کو پہلے پانی کے بعد جب کھیت تر و تر حالت میں ہو اور جڑی بوٹیاں 3 سے 5 پتوں کی حالت میں ہوں تو ہینڈ سپرے یا بوم سپرے سے سپرے کریں۔',
      '100 تا 150 لیٹر صاف پانی فی ایکڑ استعمال کریں۔',
      'تیز ہوا کے دوران سپرے نہ کریں۔'
    ]
  },
  'gengwei-55-sc-500-imported': {
    urduName: 'گینگوئی 55% SC امپورٹڈ (500ml)',
    technicalContent: 'Active Ingredients: Mesotrione 50 gm/Ltr + Atrazine 500 gm/Ltr — Selective Maize Herbicide',
    about: [
      'گینگوئی مکئی کی تمام جڑی بوٹیوں (ڈیلا اور چوڑے پتے والی) کا مکمل صفایا کرتا ہے۔'
    ],
    modeOfAction: 'جڑی بوٹیوں میں کلوروفل بننے کا عمل روک کر ان کو مکمل خشک کرتا ہے۔',
    dosageTable: [
      { crop: 'Maize (مکئی)', urduCrop: 'مکئی', target: 'گھاس نما اور چوڑے پتے والی جڑی بوٹیاں', dosage: '495 – 727.2 ml / acre', water: '100 – 150 L' }
    ],
    urduInstructions: [
      'زمین میں وتر کی موجودگی میں سپرے کریں۔'
    ]
  },
  'gengwei-55-sc-1000': {
    urduName: 'گینگوئی 55% SC (1000ml)',
    technicalContent: 'Active Ingredients: Mesotrione 50 gm/Ltr + Atrazine 500 gm/Ltr — Selective Maize Herbicide',
    about: [
      'گینگوئی مکئی کی تمام جڑی بوٹیوں (ڈیلا اور چوڑے پتے والی) کا مکمل صفایا کرتا ہے۔'
    ],
    modeOfAction: 'جڑی بوٹیوں میں کلوروفل بننے کا عمل روک کر ان کو مکمل خشک کرتا ہے۔',
    dosageTable: [
      { crop: 'Maize (مکئی)', urduCrop: 'مکئی', target: 'گھاس نما اور چوڑے پتے والی جڑی بوٹیاں', dosage: '495 – 727.2 ml / acre', water: '100 – 150 L' }
    ],
    urduInstructions: [
      'زمین میں وتر کی موجودگی میں سپرے کریں۔'
    ]
  },

  // 14. Lambda Cyhalothrin 2.5% EC
  'lamdacyhalothrin-2-5-1000': {
    urduName: 'لیمبڈا سائہیلوتھرین 2.5% EC (1000ml)',
    technicalContent: 'Active Ingredient: Lambda Cyhalothrin 25gm/Ltr (2.78% w/w) — Synthetic Pyrethroid Multi-Crop Insecticide',
    about: [
      'لیمبڈا سائہیلوتھرین ایک نہایت موثر اور وسیع العمل کیڑے مار زہر ہے جس کا تعلق پائریٹھرائیڈ گروپ سے ہے۔',
      'یہ زہر کپاس کی دشمن سنڈیوں کو ہلاک کرنے کی بے مثال طاقت رکھتا ہے۔ اس کے علاوہ اس میں سنڈیوں کے انڈے ضائع کرنے کی بھی صلاحیت موجود ہے۔',
      'لیمبڈا سائہیلوتھرین اپنے طاقتور اجزاء اور لمسی و خوراکی اثر کی بدولت حملہ آور کیڑوں پر دیر پا اثر رکھتا ہے۔',
      'ہر قسم کے موسم میں یکساں موثر ہے۔ کپاس، چاول، چنا، آم، بینگن اور بھنڈی میں سنڈیوں اور رس چوسنے والے کیڑوں کا خاتمہ کرتا ہے۔'
    ],
    modeOfAction: 'کیڑوں کے اعصابی خلیات کے سوڈیم چینلز کو غیر فعال کر کے تیز رفتار ناک ڈاؤن، فالج اور موت کا سبب بنتا ہے۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'ٹینڈے کی سنڈیاں، سبز تیلا، سفید مکھی، تھرپس', dosage: '330 ml / acre (۳۳۰ ملی لیٹر)', water: '100 – 120 L' },
      { crop: 'Chickpea / Gram (چنا)', urduCrop: 'چنا', target: 'پوڈ بورر (سوراخ کرنے والا کیڑا)', dosage: '250 ml / acre (۲۵۰ ملی لیٹر)', water: '100 L' },
      { crop: 'Mango (آم)', urduCrop: 'آم', target: 'ہا پرز (Mango Hoppers)', dosage: '40 ml / 100L water', water: '150 – 200 L' },
      { crop: 'Rice (چاول)', urduCrop: 'چاول', target: 'تنے کی سنڈی اور پتے لپیٹ سنڈی', dosage: '250 ml / acre (۲۵۰ ملی لیٹر)', water: '100 – 120 L' },
      { crop: 'Brinjal & Okra (بینگن اور بھنڈی)', urduCrop: 'بینگن اور بھنڈی', target: 'فروٹ بورر (Fruit Borer)', dosage: '200 ml / acre (۲۰۰ ملی لیٹر)', water: '100 L' }
    ],
    urduInstructions: [
      'سپرے صبح یا شام کے وقت ٹھنڈے موسم میں کریں۔',
      'سپرے کے دوران حفاظتی لباس اور ماسک استعمال کریں۔',
      'استعمال سے قبل بوتل کو اچھی طرح ہلا لیں۔'
    ]
  },
  'lamdacyhalothrin-2-5-500': {
    urduName: 'لیمبڈا سائہیلوتھرین 2.5% EC (500ml)',
    technicalContent: 'Active Ingredient: Lambda Cyhalothrin 25gm/Ltr (2.78% w/w) — Synthetic Pyrethroid Multi-Crop Insecticide',
    about: [
      'لیمبڈا سائہیلوتھرین ایک نہایت موثر اور وسیع العمل کیڑے مار زہر ہے جو سنڈیوں اور رس چوسنے والے کیڑوں کا خاتمہ کرتا ہے۔'
    ],
    modeOfAction: 'اعصابی نظام کو فالج زدہ کر کے فوری ہلاک کرتا ہے۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'ٹینڈے کی سنڈیاں، سبز تیلا اور تھرپس', dosage: '330 ml / acre', water: '100 – 120 L' },
      { crop: 'Rice (چاول)', urduCrop: 'چاول', target: 'تنے کی سنڈی اور پتہ لپیٹ سنڈی', dosage: '250 ml / acre', water: '100 – 120 L' }
    ],
    urduInstructions: [
      'حفاظتی تدابیر اختیار کریں۔'
    ]
  },
  'lamdacyhalothrin-2-5-250': {
    urduName: 'لیمبڈا سائہیلوتھرین 2.5% EC (250ml)',
    technicalContent: 'Active Ingredient: Lambda Cyhalothrin 25gm/Ltr (2.78% w/w) — Synthetic Pyrethroid Multi-Crop Insecticide',
    about: [
      'لیمبڈا سائہیلوتھرین ایک نہایت موثر اور وسیع العمل کیڑے مار زہر ہے۔'
    ],
    modeOfAction: 'اعصابی نظام کو فالج زدہ کر کے فوری ہلاک کرتا ہے۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'ٹینڈے کی سنڈیاں اور تھرپس', dosage: '330 ml / acre', water: '100 L' }
    ],
    urduInstructions: [
      'حفاظتی تدابیر اختیار کریں۔'
    ]
  },
  'lambda-25-wp-sachet': {
    urduName: 'لیمبڈا 2.5% WP پاؤڈر ساشے',
    technicalContent: 'Active Ingredient: Lambda Cyhalothrin 25gm/Kg (2.5% w/w) — Wettable Powder Sachet',
    about: [
      'لیمبڈا پاؤڈر ساشے فارمولیشن جو سنڈیوں اور رس چوسنے والے کیڑوں پر شاندار کنٹرول فراہم کرتی ہے۔'
    ],
    modeOfAction: 'سوڈیم چینلز کو مسدود کر کے تیز ترین ناک ڈاؤن دیتا ہے۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'ٹینڈے کی سنڈیاں اور رس چوسنے والے کیڑے', dosage: '1 Sachet / acre', water: '100 L' }
    ],
    urduInstructions: [
      'پہلے تھوڑے پانی میں گھول بنائیں۔'
    ]
  },

  // 15. Lejing 60% WDG (Pymetrozine + Dinotefuran)
  'lejing-60-wdg': {
    urduName: 'لیجنگ 60% WDG',
    technicalContent: 'Active Ingredients: Pymetrozine 400 g/kg (40% w/w) + Dinotefuran 200 g/kg (20% w/w) — Water Dispersible Granules',
    about: [
      'لیجنگ دو جدید کیمیائی اجزاء پر مشتمل ایک طاقتور کمبو ہے جو ایک زبر دست وسیع الاثر مڈل ڈاؤنسرائیت پذیر کیڑے مار زہر ہے۔',
      'یہ اپنے طاقتور لمسی اور عصبی اثرات کی بدولت کیڑوں کو ہلاک کرتا ہے۔',
      'لیجنگ اپنے منفرد اور جدید کیمیائی اجزاء کے باعث مختلف فصلوں میں رس چوسنے والے کیڑوں خصوصاً جست تیلا اور پلانٹ ہاپرز کے خلاف فوری اور دیر پا کنٹرول دیتا ہے۔'
    ],
    modeOfAction: 'پائمیٹروزین کیڑوں کے اسٹائلٹ (منہ کے ڈنک) کو مفلوج کرتی ہے جبکہ ڈائنوٹیفیوران نکوٹینک ریسیپٹرز کو بلاک کر کے رس چوسنے والے کیڑوں کو فوراً ہلاک کرتی ہے۔',
    dosageTable: [
      { crop: 'Rice / Paddy (دھان / چاول)', urduCrop: 'دھان / چاول', target: 'پلانٹ ہاپر (تیلا) اور رس چوسنے والے کیڑے', dosage: '60 سے 72 گرام فی ایکڑ', water: '100 – 120 L' },
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'سفید مکھی اور جسیڈز', dosage: '60 – 80 gm / acre', water: '100 – 120 L' }
    ],
    urduInstructions: [
      'سپرے شام کے وقت ٹھنڈے موسم میں کریں۔',
      'گرینولز کو پہلے تھوڑے پانی میں گھول کر سپرے ٹینک میں شامل کریں۔',
      'دوائی کو اصل پیکنگ میں سورج کی روشنی اور گرمی سے دور رکھیں۔'
    ]
  },

  // 16. Lufenuron 5% EC
  'leufenuron-5-ec': {
    urduName: 'لیوفینوران 5% EC',
    technicalContent: 'Active Ingredient: Lufenuron 50gm/Ltr (5.2% w/w) — Benzoylurea Insect Growth Regulator (IGR)',
    about: [
      'لیوفینوران ایک منفرد کیمسٹری اور انتہائی زبردست زہر ہے جس کا تعلق بینز ائل یوریا گروپ سے ہے۔',
      'یہ سنڈیوں کو بڑھوتری کے ایک مرحلے سے دوسرے مرحلے میں جانے میں رکاوٹ ڈال کر ہلاک کرتا ہے اور فصل سنڈیوں کے مزید نقصان سے بچ جاتی ہے۔',
      'لشکری سنڈی کی تمام حالتوں پر موثر ہے۔',
      'لیوفینوران کیڑوں کی بڑھوتری کو روکنے والی گروتھ انہبٹر (Growth Inhibitor) زہر ہے جو کیڑوں کی بیرونی جلد میں کائیٹن (Chitin) کے بننے کے عمل کو روکتا ہے۔'
    ],
    modeOfAction: 'کائیٹن بائیو سنتھیسس (Chitin Synthesis) کو منقطع کر کے سنڈیوں کو کینچلی بدلنے سے روکتا ہے جس سے سنڈیاں نئی جلد نہ بننے کی وجہ سے مر جاتی ہیں۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'لشکری سنڈی (Spodoptera / Armyworm)', dosage: '200 ml / acre (۲۰۰ ملی لیٹر)', water: '100 – 120 L' },
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'امریکن سنڈی (Helicoverpa)', dosage: '100 – 200 ml / acre', water: '100 – 120 L' },
      { crop: 'Cauliflower & Cabbage (گوبھی)', urduCrop: 'گوبھی', target: 'ڈائمنڈ بیک ماتھ اور گوبھی کا پروانہ', dosage: '200 ml / 100L water', water: '100 – 120 L' },
      { crop: 'Apple (سیب)', urduCrop: 'سیب', target: 'کوڈلنگ ماتھ (Codling Moth)', dosage: '100 ml / 100L water', water: '150 – 200 L' },
      { crop: 'Citrus (سٹرس)', urduCrop: 'سٹرس', target: 'لیف مائنر (Leafminer)', dosage: '60 ml / 100L water', water: '150 L' },
      { crop: 'Tomato, Potato, Tobacco (ٹماٹر، آلو، مرچ، تمباکو)', urduCrop: 'ٹماٹر، آلو، مرچ، تمباکو', target: 'امریکن سنڈی اور فروٹ بورر', dosage: '200 ml / acre', water: '100 L' }
    ],
    urduInstructions: [
      'سپرے صبح یا شام کے وقت ٹھنڈے موسم میں کریں۔',
      'سپرے کے دوران ناک، منہ اور آنکھوں کی حفاظت کریں۔',
      'فصل کو سپرے کے 7 تا 15 دن بعد تک نہ کاٹیں۔'
    ]
  },

  // 17. Manyu 27% FS (Seed Treatment)
  'manyu-27-fs-seed-treatment': {
    urduName: 'من یو 27% FS بیج کا علاج',
    technicalContent: 'Active Ingredients: Difenoconazole 22gm/Ltr (1.96% w/w) + Fludioxonil 22gm/Ltr (1.96% w/w) + Thiamethoxam 226gm/Ltr (20.17% w/w) — Flowable Concentrate for Seed Treatment (FS)',
    about: [
      'من یو تین مختلف زرعی زہروں پر مشتمل کمبو ہے۔ چنانچہ اس کے بیج کو لگانے سے پودے اگاؤ سے لے کر ابتدائی مرحلے تک کیڑوں کے حملے سے محفوظ رہتے ہیں۔',
      'من یو کے استعمال سے بیج اور اگتے ہوئے پودے نہ صرف رس چوسنے والے کیڑوں بلکہ پھپھوندی بیماریوں سے بھی محفوظ رہتے ہیں۔',
      'بیج کی روئیدگی اور جڑوں کے نظام کو غیر معمولی مضبوطی اور تحفظ فراہم کرتا ہے۔'
    ],
    modeOfAction: 'تھائیامیتھوکسام ابتدائی رس چوسنے والے کیڑوں اور دیمک سے بچاتا ہے، جبکہ ڈائفینوکونازول اور فلوڈیوکسونل بیج اور مٹی سے پیدا ہونے والی تمام پھپھوندی بیماریوں کا خاتمہ کرتے ہیں۔',
    dosageTable: [
      { crop: 'Wheat (گندم)', urduCrop: 'گندم', target: 'بیج سے پیدا شدہ بیماریاں، دیمک، گلٹھیوں والی بیماریاں اور دیگر کیڑے', dosage: '4.7 سے 7 گرام فی کلوگرام بیج', water: 'بیج ٹریٹمنٹ لوشن' },
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'ابتدائی رس چوسنے والے کیڑے اور جڑ کا گلنا', dosage: '5 – 8 ml / kg seed', water: 'بیج ٹریٹمنٹ' },
      { crop: 'Maize (مکئی)', urduCrop: 'مکئی', target: 'شووٹ فلائی اور مٹی کے کیڑے', dosage: '5 – 7 ml / kg seed', water: 'بیج ٹریٹمنٹ' }
    ],
    urduInstructions: [
      'بیج کو لگانے کا طریقہ: 100 کلو بیج کے لیے سفارش کردہ دوائی کو مناسب پانی میں ملا کر بیج پر اچھی طرح یکساں لیپ کریں۔',
      'بیج لگانے کے بعد ہوا دار اور سایہ دار جگہ پر خشک کر کے کاشت کریں۔',
      'دوا لگے بیج کو انسانوں یا جانوروں کی خوراک کے لیے ہرگز استعمال نہ کریں۔'
    ]
  },

  // 18. Niko 20% SG (Dinotefuran)
  'niko-20-sg': {
    urduName: 'نکو 20% SG',
    technicalContent: 'Active Ingredient: Dinotefuran 200gm/Kg (20% w/w) — 3rd Generation Neonicotinoid Soluble Granule',
    about: [
      'نکو نئی کیمسٹری پر مشتمل نیو نیکوٹینا ئیڈ گروپ کی جدید نسل سے تعلق رکھتا ہے۔',
      'فوری ایکشن جو سبز تیلا پر مکمل کنٹرول رکھتا ہے۔ خاص ریسپی کی وجہ سے فصل رہے سر سبز و شاداب۔',
      'پھول اور پھل پر پڑنے والے مومی دباؤ کو کم کرتا ہے، منفرد ساخت کی بدولت روایتی زہروں سے یکسر مختلف ہے۔ پھول اور پھل کی صحت کا ضامن۔'
    ],
    modeOfAction: 'تیز ترین سیسٹمک اور ٹرانسلیمنر صلاحیت کے ساتھ کیڑوں کے اعصاب کو فوری مفلوج کر کے 15 منٹ میں فیڈنگ روکتا ہے۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'جسیڈ (سبز تیلا)، تھرپس اور سفید مکھی', dosage: '100 gm / acre (۱۰۰ گرام فی ایکڑ)', water: '100 – 120 L' },
      { crop: 'Rice (چاول)', urduCrop: 'چاول', target: 'پلانٹ ہاپرز (BPH / WBPH)', dosage: '100 gm / acre', water: '100 – 120 L' },
      { crop: 'Vegetables (سبزیاں)', urduCrop: 'سبزیاں', target: 'سبز تیلا اور سفید مکھی', dosage: '80 – 100 gm / acre', water: '100 L' }
    ],
    urduInstructions: [
      'سپرے اور برداشت کے درمیان وقفہ: 14 دن۔',
      'زہر چونکہ پاؤڈر/گرینول حالت میں ہے اس لئے اس کی سفارش کردہ مقدار کا اچھی طرح محلول بنائیں۔',
      'سپرے کے دوران حفاظتی تدابیر اختیار کریں۔'
    ]
  },

  // 19. Paraquat 20% SL
  'paraquat-20-sl': {
    urduName: 'پیرا کاٹ 20% SL',
    technicalContent: 'Active Ingredient: Paraquat Dichloride 200gm/Ltr (18.52% w/w) — Non-Selective Contact Herbicide | Reg. No: (GENERIC)/DPP/2019(8632)',
    about: [
      'پیرا کاٹ ایک ایسی وسیع الاثر (Non Selective) جڑی بوٹی مار زہر ہے جو جڑی بوٹیوں کے پتوں اور تنوں میں جذب ہو کر خوراک بنانے کے عمل کو روکتا ہے۔',
      'جس سے تمام اقسام کی جڑی بوٹیوں کا فوری اور دیر پا خاتمہ ہو جاتا ہے۔',
      'پیرا کاٹ کو مختلف باغات اور فصلات میں جڑی بوٹیوں کے اُگنے کے بعد ان کی تلفی کے لئے نہایت کامیابی کے ساتھ استعمال کیا جاتا ہے۔',
      'سپرے کے چند گھنٹوں بعد ہی جڑی بوٹیاں جھلسنا شروع ہو جاتی ہیں۔'
    ],
    modeOfAction: 'فوٹو سسٹم I میں الیکٹران ٹرانسپورٹ کو منقطع کر کے سپر آکسائیڈ ریڈیکلز بناتا ہے جو جڑی بوٹیوں کے خلیات کی جھلیوں کو چند گھنٹوں میں جلا کر ختم کر دیتے ہیں۔',
    dosageTable: [
      { crop: 'Citrus & Orchards (سٹرس و باغات)', urduCrop: 'سٹرس و باغات', target: 'چوڑے پتوں والی اور گھاس نما جڑی بوٹیاں، ڈیلا خاندان Sedges (اُگنے کے بعد)', dosage: '1000 – 1500 ml / acre', water: '120 – 150 L' },
      { crop: 'Uncultivated / Bunds (غیر مزروعہ رقبہ و وٹیں)', urduCrop: 'غیر مزروعہ رقبہ', target: 'ہر قسم کی خودرو جڑی بوٹیاں اور جھاڑیاں', dosage: '1000 – 1500 ml / acre', water: '120 – 150 L' }
    ],
    urduInstructions: [
      'جڑی بوٹیوں کے سپرے کے لئے کٹ نوزل یا فلڈ جیٹ نوزل کا استعمال کریں۔',
      'پھلدار پودوں کے تنوں اور پتوں پر سپرے نہ پڑنے دیں۔ ہوڈ (Hood) کا استعمال کریں۔',
      'سپرے کے دوران حفاظتی چشمہ اور دستانے لازمی استعمال کریں۔'
    ]
  },

  // 20. Pendi + Acetachlor 42% EC
  'pendi-acetachlor-42-ec': {
    urduName: 'اسیٹوکلور + پینڈی میتھالین 42% EC',
    technicalContent: 'Active Ingredients: Acetochlor 250 gm/Ltr (25.51% w/w) + Pendimethalin 170 gm/Ltr (17.34% w/w) — Pre-Emergence Cotton Herbicide',
    about: [
      'اسیٹوکلور + پینڈی میتھالین دو مختلف جڑی بوٹی مار زہروں کا ایک بہترین مکسچر ہے۔',
      'کپاس کو اگاؤ سے ہی جڑی بوٹیوں سے پاک اور صاف رکھنا بہت اہم مرحلہ ہے چونکہ اس کے استعمال سے فصل شروع سے ہی جڑی بوٹیوں کے دباؤ سے آزاد رہتی ہے اور فصل کی بڑھوتری شاندار ہوتی ہے۔',
      'اس کا سپرے فصل کے اگاؤ اور بڑھوتری کے عمل کو متاثر نہیں کرتا۔'
    ],
    modeOfAction: 'پینڈی میتھالین مائیکروٹیوبیول اسمبلی کو اور اسیٹوکلور سیل ڈویژن میں لمبی چین والے فیٹی ایسڈز کی تالیف کو روکتی ہے جس سے جڑی بوٹیوں کا اگاؤ ہی نہیں ہوتا۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'چوڑے پتوں والی اور گھاس نما جڑی بوٹیاں (Pre-Emergence Weeds)', dosage: '1000 ml / acre (۱۰۰۰ ملی لیٹر)', water: '100 – 120 L' }
    ],
    urduInstructions: [
      'کپاس کی بوائی کے بعد اور اگاؤ سے پہلے زمین میں وتر (نمی) کی مناسب حالت میں سپرے کریں۔',
      'کھیلیوں پر کاشت کی صورت میں بوائی کے بعد 24 سے 48 گھنٹوں کے اندر سپرے کریں۔',
      'فلڈ جیٹ یا ٹی جیٹ نوزل کا استعمال کریں۔'
    ]
  },
  'pendimethalin-33-ec': {
    urduName: 'پینڈی میتھالین 33% EC',
    technicalContent: 'Active Ingredient: Pendimethalin 330gm/Ltr (33% w/w) — Pre-Emergence Herbicide',
    about: [
      'کپاس، گندم اور سبزیوں میں جڑی بوٹیوں کے اگاؤ سے قبل استعمال ہونے والا زہر۔',
      'زمین میں ایک محفوظ تہہ بنا کر گھاس نما اور چوڑے پتے والی جڑی بوٹیوں کو اگنے سے روکتا ہے۔'
    ],
    modeOfAction: 'سیل ڈویژن کو روک کر جڑی بوٹیوں کی جڑوں اور کونپلوں کا اگاؤ ختم کرتا ہے۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'ابتدائی سالانہ جڑی بوٹیاں (اُگنے سے پہلے)', dosage: '800 – 1000 ml / acre', water: '100 – 120 L' }
    ],
    urduInstructions: [
      'بوائی کے فوراً بعد وتر حالت میں سپرے کریں۔'
    ]
  },

  // 21. Pyriproxyfen 10.8% EC
  'pyriprixifin-10-8-ec': {
    urduName: 'پائری پروکسی فن 10.8% EC',
    technicalContent: 'Active Ingredient: Pyriproxyfen 108gm/Ltr (11.48% w/w) — Juvenile Hormone Mimic Insect Growth Regulator (IGR)',
    about: [
      'پائری پروکسی فن ایک نباتیاتی مرکب ہے، جو اپنے لمسی اور خوراکی اثر کی وجہ سے کیڑوں میں رونما ہونے والے قدرتی عمل میں خلل ڈال کر ان کو زندگی کے نئے مراحل میں داخل ہونے سے روکتا ہے۔ جس سے کیڑے اسی حالت میں مر جاتے ہیں۔',
      'پائری پروکسی فن کیڑوں میں نئی نسل کشی اور کینچلی اترنے میں رکاوٹ ڈالتی ہے۔ دنیا بھر میں یہ زہر اسکیلز ، سفید مکھی ، تھرپس ، مکھیاں اور مچھروں وغیرہ کو ختم کرنے کیلئے بڑی کامیابی سے استعمال ہو رہا ہے۔',
      'پائری پروکسی فن پتہ مروڑ وائرس (CLCV) کے مینجمنٹ پروگرام کا اہم ترین جزو ہے۔',
      'پائری پروکسی فن کے استعمال سے سرسبز و شاداب فصل، وزنی ٹینڈوں اور سفید کپاس کا حصول ممکن ہے۔'
    ],
    modeOfAction: 'جووینائل ہارمون میمک کے طور پر کام کر کے سفید مکھی کے انڈوں اور بچوں کو جوان بننے سے روکتا ہے اور مادہ کیڑوں کو بانجھ بنا دیتا ہے۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'سفید مکھی کے انڈے، بچے اور بالغ (Whitefly Control & CLCV Management)', dosage: '500 ml / acre (۵۰۰ ملی لیٹر)', water: '100 – 120 L' },
      { crop: 'Vegetables (سبزیاں)', urduCrop: 'سبزیاں', target: 'سفید مکھی اور اسکیلز', dosage: '400 – 500 ml / acre', water: '100 L' },
      { crop: 'Citrus (باغات)', urduCrop: 'باغات', target: 'سٹرس اسکیلز اور سفید مکھی', dosage: '100 ml / 100L water', water: '150 – 200 L' }
    ],
    urduInstructions: [
      'سفید مکھی کے انڈوں اور بچوں کے ابتدائی مشاہدے پر سپرے کریں۔',
      'سپرے صبح یا شام کے ٹھنڈے اوقات میں کریں۔',
      'سپرے کے بعد 10 دن تک فصل کو نہ کاٹیں۔'
    ]
  },

  // 22. Sadi 25% ZC (Lambda + Clothianidin)
  'sadi-25-zc': {
    urduName: 'سادی 25% ZC',
    technicalContent: 'Active Ingredients: Lambda Cyhalothrin 13.2% w/v (12% w/w) + Clothianidin 14.3% w/v (13% w/w) — Advanced Mixed Microcapsule Formulation (ZC)',
    about: [
      'سادی ایک جدید منفرد اور زرعی زہروں (لیمبڈا سائہیلوتھرین اور کلوتھیانیڈن) کا مرکب ہے اور یہ جدید فارمولیشن زیڈ سی کی بدولت کیڑوں کا موثر کنٹرول کرتا ہے۔',
      'سادی لمسی (Contact)، معدی (Stomach)، سرایت پذیری (Systemic) اور پودوں کے آر پار ہونے کی صلاحیت سے مختلف فصلوں میں رس چوسنے والے کیڑوں کو کنٹرول کرنے کی زبردست صلاحیت رکھتا ہے۔',
      'سادی کیڑوں کو کنٹرول کر کے فصل کی نشوونما کو بہتر کرتا ہے۔ مائیکرو کیپسول ٹیکنالوجی کی بدولت دیرپا تحفظ فراہم کرتا ہے۔'
    ],
    modeOfAction: 'دوہری کیمسٹری: کلوتھیانیڈن جڑوں اور پتوں کے ذریعے جذب ہو کر رس چوسنے والے کیڑوں کو اور لیمبڈا سائہیلوتھرین لمسی اثر سے فوری سنڈیوں کو ناک ڈاؤن کرتی ہے۔',
    dosageTable: [
      { crop: 'Cabbage & Kale (بند گوبھی، کیلی)', urduCrop: 'بند گوبھی، کیلی', target: 'سفید مکھی، سنڈیاں اور کیٹرپلرز', dosage: '121 سے 181 ملی لیٹر فی ایکڑ', water: '100 – 120 L' },
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'سفید مکھی، جسیڈ، تھرپس اور سنڈیاں', dosage: '150 – 200 ml / acre', water: '100 – 120 L' },
      { crop: 'Rice (چاول)', urduCrop: 'چاول', target: 'پلانٹ ہاپرز اور سنڈیاں', dosage: '150 – 200 ml / acre', water: '100 – 120 L' }
    ],
    urduInstructions: [
      'سپرے اور برداشت کے درمیان وقفہ: 7 تا 15 دن۔',
      'سفارش کردہ مقدار کا محلول تیار کریں اور اچھے پریشر کے ساتھ پودے کو اچھی طرح تر کریں۔',
      'سپرے صبح یا شام کے وقت کریں۔'
    ]
  },

  // 23. Sega Pest Clear 3% SC (Emamectin + Lufenuron)
  'sega-pest-clear-3-400': {
    urduName: 'سیگا پیسٹ کلئیر 3% SC (400ml)',
    technicalContent: 'Active Ingredients: Emamectin Benzoate 10gm/Ltr (0.966% w/w) + Lufenuron 20gm/Ltr (1.936% w/w) — Synergistic Suspension Concentrate',
    about: [
      'سیگا پیسٹ کلئیر دنیا کا بہترین وسیع دائرہ اثر والا نیو کیمسٹری کیڑے مار زہر ہے جو کہ دو طاقتور کیڑے مار زہروں کا شاندار مرکب ہے جن کو ایک خاص تناسب سے ملایا گیا ہے۔',
      'سیگا پیسٹ کلئیر تین مختلف طریقوں لمسی (Contact)، شکمی (Stomach) اور پودوں سے آر پار ہونے کی صلاحیت (Translaminar) سے سنڈیوں کو کنٹرول کرنے کی زبردست صلاحیت رکھتا ہے۔',
      'سیگا پیسٹ کلئیر کیڑوں کو فوری طور پر کنٹرول کر کے فصل کو قدرتی حالت میں سرسبز و شاداب رکھتا ہے اور پیداوار میں یقینی اضافہ کا باعث بنتا ہے۔'
    ],
    modeOfAction: 'ایمامیکٹن سنڈیوں کے اعصاب کو مفلوج کر کے فوری فیڈنگ بند کرواتا ہے جبکہ لیوفینوران سنڈیوں کی نئی جلد بننے کا عمل روک کر اگلی نسل کا مکمل صفایا کرتی ہے۔',
    dosageTable: [
      { crop: 'Forest Woods & Crops (فارسٹ ووڈز و فصلات)', urduCrop: 'فارسٹ ووڈز و فصلات', target: 'فال ویب ورم، سنڈیاں (Fall Webworm & Caterpillars)', dosage: '15 سے 20 ملی لیٹر فی 100 لیٹر پانی', water: '100 – 150 L' },
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'لشکری سنڈی، امریکن سنڈی اور گلابی سنڈی', dosage: '200 – 250 ml / acre', water: '100 – 120 L' },
      { crop: 'Maize (مکئی)', urduCrop: 'مکئی', target: 'فال آرمی ورم', dosage: '200 – 250 ml / acre', water: '100 L' }
    ],
    urduInstructions: [
      'سپرے صبح یا شام کے وقت ٹھنڈے موسم میں کریں۔',
      'سپرے ٹینک کو پانی سے آدھا بھریں، تیار شدہ محلول ڈال کر بقیہ پانی بھریں۔',
      'سپرے کے بعد 21 دن تک فصل کو نہ کاٹیں (PHI: 21 Days)۔'
    ]
  },
  'sega-pest-clear-3-1000': {
    urduName: 'سیگا پیسٹ کلئیر 3% SC (1000ml)',
    technicalContent: 'Active Ingredients: Emamectin Benzoate 10gm/Ltr + Lufenuron 20gm/Ltr — Synergistic Suspension Concentrate',
    about: [
      'سیگا پیسٹ کلئیر دو طاقتور اجزاء کا شاندار مرکب ہے جو سنڈیوں کا فوری اور دیرپا خاتمہ کرتا ہے۔'
    ],
    modeOfAction: 'اعصابی فالج اور گروتھ انہبیشن کے ذریعے سنڈیوں کی تمام حالتوں کا خاتمہ۔',
    dosageTable: [
      { crop: 'Cotton & Maize (کپاس و مکئی)', urduCrop: 'کپاس و مکئی', target: 'لشکری سنڈی اور فال آرمی ورم', dosage: '200 – 250 ml / acre', water: '100 – 120 L' }
    ],
    urduInstructions: [
      'سپرے ٹھنڈے اوقات میں کریں۔'
    ]
  },

  // 24. Shiding 21% EC (Triazophos + Lambda)
  'shiding-21-ec': {
    urduName: 'شائیڈنگ 21% EC',
    technicalContent: 'Active Ingredients: Lambda Cyhalothrin 10gm/Ltr (0.95% w/w) + Triazophos 200gm/Ltr (19.70% w/w) — Dual Action Insecticide',
    about: [
      'شائیڈنگ دو مختلف گروپوں سے تعلق رکھنے والا دنیا کا بہترین کیڑے مار زہر ہے۔',
      'شائیڈنگ لمسی (Contact) اور شکمی (Stomach) اثر سے مضر سنڈیوں (امریکن سنڈی، چتکبری سنڈی اور گلابی سنڈی) بلکہ رس چوسنے والے کیڑوں (کپاس کی بگ، ڈسکی کاٹن بگ، اور ریڈ کاٹن بگ) کو کنٹرول کرنے کی زبردست صلاحیت رکھتا ہے۔',
      'شائیڈنگ وسیع دائرہ اثر رکھتا ہے | فصل سے بہترین مطابقت رکھتا ہے | فصل کو سرسبز و شاداب بناتا ہے اور پیداوار میں یقینی اضافہ کرتا ہے۔'
    ],
    modeOfAction: 'ٹرائیازوفاس کی گہری سرائیت پذیری اور لیمبڈا کی تیز رفتار ناک ڈاؤن سنڈیوں اور کیڑوں کی تمام حالتوں پر کاری ضرب لگاتی ہے۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'امریکن، چتکبری اور گلابی سنڈی، ڈسکی کاٹن بگ اور ریڈ کاٹن بگ', dosage: '89 سے 102 ملی لیٹر فی ایکڑ', water: '100 – 120 L' },
      { crop: 'Vegetables (سبزیاں)', urduCrop: 'سبزیاں', target: 'سنڈیاں اور بگز', dosage: '100 – 150 ml / acre', water: '100 L' }
    ],
    urduInstructions: [
      'سپرے اور برداشت کا درمیانی وقفہ: 30 دن۔',
      'استعمال سے قبل بوتل کو اچھی طرح ہلا لیں۔',
      'حفاظتی چشمہ اور ماسک لازمی پہنیں۔'
    ]
  },

  // 25. Togo 30% SC (Chlorantraniliprole + Methoxyfenozide)
  'togo-30-sc': {
    urduName: 'ٹوگو 30% SC',
    technicalContent: 'Active Ingredients: Chlorantraniliprole 110 gm/ltr (10% w/w) + Methoxyfenozide 221 gm/ltr (20% w/w) — Premium Lepidopteran Control Suspension',
    about: [
      'دنیا کا بہترین وسیع الاثر اور تیز اثر رکھنے والا پیچیدہ کیمسٹری کیڑے مار زہر ہے جو کہ دو طاقتور زہروں کا شاندار مرکب ہے۔ ٹوگو میں دو نئی اور جدید کیڑے مار زہروں کو خاص تناسب سے ملایا گیا ہے۔',
      'ٹوگو تین مختلف طریقوں لمسی (Contact)، معدی (Stomach) اور پودوں کے آر پار ہونے کی صلاحیت (Translaminar) سے کیڑوں کو کنٹرول کرنے کی زبردست اہلیت رکھتا ہے۔',
      'ٹوگو کیڑوں کو فوری طور پر کنٹرول کر کے فصل کو قدرتی حالت میں سرسبز و شاداب رکھتا ہے اور پیداوار میں یقینی اضافہ کرتا ہے۔'
    ],
    modeOfAction: 'میتھوکسی فینوزائیڈ سنڈیوں میں قبل از وقت کینچلی اتروانے (Moulting Accelerating) کا سبب بنتی ہے اور کلورانٹرانیلیپرول پٹھوں کے کیلشیم چینلز کو مستقل کھول کر سنڈیوں کو مفلوج کر دیتا ہے۔',
    dosageTable: [
      { crop: 'Maize (مکئی)', urduCrop: 'مکئی', target: 'مکئی کی سنڈیاں اور فال آرمی ورم (Fall Armyworm)', dosage: '4 – 8 ml / 667m² (60 – 120 ml / ha)', water: '100 – 120 L' },
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'لشکری سنڈی اور امریکن سنڈی', dosage: '60 – 80 ml / acre', water: '100 – 120 L' },
      { crop: 'Rice (چاول)', urduCrop: 'چاول', target: 'پتہ لپیٹ سنڈی اور تنے کی سنڈی', dosage: '50 – 70 ml / acre', water: '100 L' }
    ],
    urduInstructions: [
      'سپرے اور برداشت کے درمیان وقفہ: 28 دن (PHI: 28 Days)۔',
      'سپرے اس طرح کریں کہ پودے کے تمام حصوں تک زہر اچھی طرح پہنچ جائے۔',
      'سپرے کے بعد ہاتھ منہ صابن اور صاف پانی سے دھو لیں۔'
    ]
  }
};

// Fallback category templates for remaining products
export const defaultCategorySpecs = {
  Insecticide: {
    about: [
      'وسیع الاثر اور تیز رفتار اثر رکھنے والا زرعی حشرات کش زہر جو فصل کو نقصان رساں سنڈیوں اور رس چوسنے والے کیڑوں سے پاک رکھتا ہے۔',
      'پودوں میں فوری جذب ہو کر کیڑوں کی خوراک کو فوری روکتا ہے اور فصل کے نقصان کا فوری سدباب کرتا ہے۔',
      'فصل کو دیرپا تحفظ فراہم کر کے سرسبز، شاداب اور صحت مند بناتا ہے۔'
    ],
    technicalContent: 'Specialized High-Grade Crop Protection Insecticide',
    modeOfAction: 'لمسی اور خوراکی اثر کے ذریعے کیڑوں کے اعصابی اور عضلاتی نظام کو مفلوج کر کے ہلاک کرتا ہے۔',
    dosageTable: [
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'سنڈیاں اور رس چوسنے والے کیڑے', dosage: '250 – 400 ml / acre', water: '100 – 120 L' },
      { crop: 'Rice (چاول)', urduCrop: 'چاول', target: 'تنے کی سنڈی اور پتہ لپیٹ سنڈی', dosage: '250 – 500 ml / acre', water: '100 – 120 L' },
      { crop: 'Maize (مکئی)', urduCrop: 'مکئی', target: 'فال آرمی ورم اور سنڈیاں', dosage: '200 – 350 ml / acre', water: '100 – 120 L' },
      { crop: 'Vegetables (سبزیاں)', urduCrop: 'سبزیاں', target: 'ایفڈز، تھرپس اور کیٹرپلرز', dosage: '150 – 300 ml / acre', water: '100 L' }
    ],
    urduInstructions: [
      'فصل پر سپرے صبح کے وقت یا شام کو ٹھنڈے موسم میں کریں۔',
      'سپرے کے دوران حفاظتی دستانے اور ماسک کا لازمی استعمال کریں۔',
      'دوائی کو بچوں اور مویشیوں کی پہنچ سے دور خشک اور سایہ دار جگہ پر اسٹور کریں۔',
      'سپرے کے بعد ہاتھ اور منہ صابن سے اچھی طرح دھو لیں۔'
    ]
  },
  Fungicide: {
    about: [
      'اعلیٰ معیار کا حفاظتی اور سرائیت پذیر پھپھوندی کش زہر جو پودے کے خلیات میں گہرائی تک سرائیت کر کے پھپھوندی بیماریوں کو جڑ سے ختم کرتا ہے۔',
      'پھپھوندی کے بیجوں (Spores) کے اگاؤ کو روک کر بیماری کو پھیلنے سے روکتا ہے۔',
      'فصل کے پتوں کو دیرپا سرسبز رکھ کر پیداوار میں بھرپور اضافہ کرتا ہے۔'
    ],
    technicalContent: 'Systemic Antifungal Crop Protection Formulation',
    modeOfAction: 'پھپھوندی کے خلیاتی نظام اور توانائی کی پیداوار کو مسدود کر کے بیماری کے پھیلاؤ کو فوری روکتا ہے۔',
    dosageTable: [
      { crop: 'Wheat (گندم)', urduCrop: 'گندم', target: 'کنگی (رسٹ) اور سفوفی پھپھوندی', dosage: '200 – 250 ml/gm / acre', water: '100 – 120 L' },
      { crop: 'Rice (چاول)', urduCrop: 'چاول', target: 'بلاسٹ اور براؤن اسپاٹ', dosage: '250 – 400 ml/gm / acre', water: '100 – 120 L' },
      { crop: 'Vegetables & Potato (آلو و سبزیاں)', urduCrop: 'آلو و سبزیاں', target: 'اگیتی و پچھیتی جھلساؤ (Blight)', dosage: '250 – 500 ml/gm / acre', water: '100 – 120 L' }
    ],
    urduInstructions: [
      'بیماری کے ابتدائی علامات ظاہر ہوتے ہی پہلا سپرے کریں اور ضرورت پڑنے پر 10 سے 12 دن بعد دہرائیں۔',
      'سپرے کا گھول صاف پانی میں تیار کریں اور مناسب پریشر والی نوزل استعمال کریں۔',
      'دوائی کو دھوپ اور زیادہ گرمی سے محفوظ رکھیں۔'
    ]
  },
  Herbicide: {
    about: [
      'انتخابی اور غیر انتخابی جڑی بوٹی مار زہر جو چوڑے پتوں اور گھاس نما جڑی بوٹیوں کا مکمل خاتمہ کرتا ہے۔',
      'فصل کو جڑی بوٹیوں کے منفی اثرات، غذائی اجزاء اور پانی کے مقابلے سے نجات دلاتا ہے۔',
      'فصل کی ابتدائی اور حتمی بڑھوتری کو شاندار اور پیداوار کو زیادہ بناتا ہے۔'
    ],
    technicalContent: 'Selective / Non-Selective Herbicide Formulation',
    modeOfAction: 'جڑی بوٹیوں کی جڑوں اور پتوں کے ذریعے جذب ہو کر ان کی نشوونما اور خوراک بنانے کا عمل مستقل روک دیتا ہے۔',
    dosageTable: [
      { crop: 'Wheat (گندم)', urduCrop: 'گندم', target: 'دمبی گھاس، جنگلی جئی، باتھو اور دیگر جڑی بوٹیاں', dosage: '300 – 500 ml/gm / acre', water: '100 – 120 L' },
      { crop: 'Maize (مکئی)', urduCrop: 'مکئی', target: 'ڈیلا، اتھ سٹ اور چوڑے پتے والی جڑی بوٹیاں', dosage: '500 – 1000 ml / acre', water: '100 – 120 L' },
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'اُگنے سے پہلے اور بعد کی جڑی بوٹیاں', dosage: '800 – 1000 ml / acre', water: '100 – 120 L' }
    ],
    urduInstructions: [
      'جڑی بوٹی مار ادویات کے لیے کٹ یا فلڈ جیٹ نوزل کا استعمال کریں۔',
      'زمین میں مناسب وتر (نمی) کی موجودگی میں سپرے کریں۔',
      'تیز ہوا میں سپرے نہ کریں تاکہ دیگر فصلیں محفوظ رہیں۔'
    ]
  },
  'Fertilizers & Nutrients': {
    about: [
      'اعلیٰ درجے کی زرعی غذائیت اور مائیکرو و میکرو نیوٹرینٹس جو پودے کی مکمل نشوونما اور مضبوطی کا ضامن ہیں۔',
      'جڑوں کے نظام کو پھیلاتا ہے، ٹیلرز کی تعداد بڑھاتا ہے اور پھل و پھول کے گرنے کو روکتا ہے۔',
      'موسمیاتی دباؤ، گرمی اور خشکی کے خلاف پودے میں بھرپور قوت مدافعت پیدا کرتا ہے۔'
    ],
    technicalContent: 'High-Efficiency Bio-Nutrition & Chelated Trace Minerals',
    modeOfAction: 'پتوں اور جڑوں کے ذریعے فوری جذب ہو کر پودے کے میٹابولزم اور کلوروفل کی مقدار کو تیز کرتا ہے۔',
    dosageTable: [
      { crop: 'Wheat (گندم)', urduCrop: 'گندم', target: 'شاخیں بننے اور دانے کا وزن بڑھانے کیلئے', dosage: '500 – 1000 ml/gm / acre', water: '100 – 120 L' },
      { crop: 'Cotton (کپاس)', urduCrop: 'کپاس', target: 'ڈوڈیاں بننے اور ٹینڈوں کے وزن میں اضافہ کیلئے', dosage: '1 – 2 L/kg / acre', water: '100 – 120 L' },
      { crop: 'Maize & Sugarcane (مکئی و گنا)', urduCrop: 'مکئی و گنا', target: 'چھلی کا سائز، تنے کی موٹائی اور پیداوار بڑھانے کیلئے', dosage: '1 – 3 L/kg / acre', water: '120 – 150 L' },
      { crop: 'Vegetables & Orchards (سبزیاں و باغات)', urduCrop: 'سبزیاں و باغات', target: 'پھل کا سائز، رنگت، چمک اور کوالٹی بڑھانے کیلئے', dosage: '500 – 1000 ml/gm / acre', water: '100 – 150 L' }
    ],
    urduInstructions: [
      'کھاد کا سپرے پودوں کی اہم نشوونما کے مراحل پر کریں۔',
      'پاؤڈر کھاد کو پہلے تھوڑے پانی میں مکمل حل کر کے سپرے ٹینک میں شامل کریں۔',
      'بوری یا بوتل کو ہوا بند کر کے خشک اور محفوظ جگہ پر رکھیں۔'
    ]
  }
};

export function getProductSpecs(product) {
  if (!product) return null;
  const categoryKey = product.category || 'Insecticide';
  const baseSpecs = defaultCategorySpecs[categoryKey] || defaultCategorySpecs.Insecticide;
  const specific = specificProductSpecs[product.slug] || {};

  return {
    urduName: specific.urduName || product.name,
    about: specific.about || baseSpecs.about,
    technicalContent: specific.technicalContent || `${product.name} — ${baseSpecs.technicalContent}`,
    modeOfAction: specific.modeOfAction || baseSpecs.modeOfAction,
    dosageTable: specific.dosageTable || baseSpecs.dosageTable,
    urduInstructions: specific.urduInstructions || baseSpecs.urduInstructions
  };
}
